import _compact from 'lodash/compact';
import _includes from 'lodash/includes';
import _join from 'lodash/join';
import _replace from 'lodash/replace';
import _split from 'lodash/split';
import _toString from 'lodash/toString';
import _isString from 'lodash/isString';

export default (link, lang) => {
  let newLink = link;
  if(_isString(link) && lang){
    newLink = setLinkParam(link, 'lang', lang);
  }

  return newLink;
}

let setLinkParam = (link, key, value) => {
  let result = link;
  let isHttpLink = /(http|https):\/\//g.test(link);
  let path = _join(_compact(_split(link, '/')), '/');

  let new_link = (isHttpLink) ? link : window.location.origin + (_includes(link, '/') ? '' : window.location.pathname) + '/' + path;

  let parseURL = new URL(new_link);
  if (parseURL.origin && parseURL.host == window.location.host && !/:/g.test(parseURL.pathname)) {
    parseURL.searchParams.set(key, value);
    if (isHttpLink) {
      result = parseURL.toString();
    }else{
      result = _replace(parseURL.toString(), window.location.origin, '');
    }
  }

  return result;
}
